// Minimal toast — capture feedback ("Saved ✓") without a UI framework.
export function toast(message: string, kind: 'ok' | 'warn' = 'ok'): void {
  const el = document.createElement('div');
  el.className = `toast toast--${kind}`;
  el.textContent = message;
  document.body.appendChild(el);
  // Force reflow so the enter transition runs.
  void el.offsetWidth;
  el.classList.add('toast--show');
  setTimeout(() => {
    el.classList.remove('toast--show');
    setTimeout(() => el.remove(), 250);
  }, 1900);
}
